import {Injectable} from '@angular/core';

import {LocalStorageService} from './local-storage.service';
import {TokenUserModel} from 'shared/models';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  private _token?: string;
  private _user?: TokenUserModel;

  constructor(private localStorageService: LocalStorageService) {}

  get token(): string | undefined {
    return this._token;
  }

  set token(token: string) {
    this._token = token;
  }

  get currentUser(): TokenUserModel | undefined {
    return this._user;
  }

  set currentUser(user: TokenUserModel) {
    this._user = user;
  }

  login(token: string, tokenUser: TokenUserModel): void {
    this.token = token;
    this.currentUser = tokenUser;
    this.localStorageService.setItem('t', token);
  }

  logout(): void {
    this._token = undefined;
    this._user = undefined;
    this.localStorageService.removeItem('t');
  }
}
